import { Logger } from '@vue-storefront/core';
import { Context } from '@nuxt/types';
import { extractPathFromUrl } from '~/helpers/utils';

export default async function (context: Context) {
  const supportedLocales = ['nl', 'fr', 'en', 'de', 'it', 'es'];
  const url = process.server ? context.req.url : context.route.path;
  const route = url ?? '';
  const pathName = extractPathFromUrl(route);
  const firstSegment = url?.split('/')[1];

  if (firstSegment?.length === 2 && !supportedLocales.includes(firstSegment)) {
    Logger.error('[validate-locale] prefix is not a supported lang', pathName);

    context.error({ statusCode: 404, message: 'Page not found' });
  }
}
